import { render, staticRenderFns } from "./Headquarter.vue?vue&type=template&id=344d50e4&scoped=true&"
import script from "./Headquarter.vue?vue&type=script&lang=js&"
export * from "./Headquarter.vue?vue&type=script&lang=js&"
import style0 from "./Headquarter.vue?vue&type=style&index=0&id=344d50e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d50e4",
  null
  
)

component.options.__file = "Headquarter.vue"
export default component.exports